import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const selectLoanEditorCustomFormsState = createSelector(
  getSystem,
  ({ loanEditorCustomForms }) => loanEditorCustomForms,
);

export const selectLoanEditorCustomForms = createSelector(
  selectLoanEditorCustomFormsState,
  state => state.forms ?? [],
);

export const selectLoanEditorCustomFormById = memoizeOne(formId =>
  createSelector(selectLoanEditorCustomForms, forms => forms.find(form => form.id === formId)),
);
